/**
 * @param {string} params.id - The unique identifier of the form.
 * @param {string} params.title - The title of the form.
 * @param {string} params.createdDateUTC - The date and time the form was created (UTC).
 * @param {string} params.status - complete, pending
 * @param {string} params.type - The type/category of the form.
 */
export default class FormDTO {
  constructor({ id, title, createdDateUTC, status, type }) {
    /**
     * @type {string}
     */
    this.id = id
    /**
     * @type {string}
     */
    this.title = title
    /**
     * @type {string|null}
     */
    this.createdDateUTC = createdDateUTC ?? null
    /**
     * @type {string}
     */
    this.status = status
    /**
     * @type {string}
     */
    this.type = type
  }
}
